import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastColors, ToastIcons, ToastTypeName } from '@pso-ui/toast-notification/Toast';

@Component({
  selector: 'app-toast-notification',
  templateUrl: './toast-notification.component.html',
  styleUrls: ['./toast-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastNotificationComponent implements OnInit {
  @Input() message: string;
  @Input() type: ToastTypeName;
  @Output() closed = new EventEmitter<void>();

  color: string;
  icon: string;

  ngOnInit(): void {
    this.color = ToastColors.hex(this.type);
    this.icon = ToastIcons.icon(this.type);
  }

  close(): void {
    this.closed.emit();
  }
}
